import { TError } from '../../models';

const MFA_REGEX = /^\d{6}$/;

export type TMFAForm = {
  code: string,
  errorApi: TError[],
};

export const onChangeMFAInput = (name: string, value: string | boolean | TError[], form: TMFAForm, updateForm: ({ code, errorApi }: TMFAForm) => void) => {
  updateForm({
    ...form,
    errorApi: [],
    [name]: name === 'code' && typeof value === 'string' ? value.replace(/\D/g, '').slice(0, 6): value,
  });
};

export const isMFAValid = (code: string) => !!(code && MFA_REGEX.test(code));
